module.exports = __webpack_public_path__ + "static/media/31.717f0017.jpg";